import yup from 'core/utils/validators';

const { object, string } = yup;

export const PIN_CODE_LENGTH = 6;

export const pinCodeFormSchema = () =>
  object().shape({
    registration_pin_code: string()
      .min(PIN_CODE_LENGTH, 'message_length')
      .required('message_required'),
  });
